import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/parameterAbstract";
import { getParameterReferences, processParameterReferences } from "./helpers/parameterHelper";

const _action = `${ACTION_PREFIX_PARAMETER}_copy`;
const _header = `Copy parameter`;

export const copyParameter = (root, id) => {
  const _payload = copyParameterLogic(root, id);

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const copyParameterLogic = (root, id) => {
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error("Node to copy not found");
  }
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));
  const { data: _nodeCopy, idTrack: _idTrack } = nodeUtils.copy(_node, { name: "" });

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getParameterReferences(root, _node);

  addNodeCopy(_nodeCopy, _nodeParent, _index + 1);
  removeReferences(_nodeCopy);

  handleReferences(_references, _idTrack);

  return generatePayload(_nodeBackup, _index, _nodeParent, _nodeCopy, _references.description);
};

const addNodeCopy = (nodeCopy, nodeParent, index) => {
  nodeUtils.modifyParameters(nodeParent, (e) => e.splice(index, 0, nodeCopy), false);
};

const removeReferences = (nodeCopy) => {
  nodeUtils.setIdReferences(nodeCopy, null);
};

const handleReferences = (references, idTrack) => {
  const funTarget = (e) => {
    nodeUtils.addIdReference(e.dst, idTrack.get(nodeUtils.getID(e.src)));
  };

  processParameterReferences(references, funTarget, funTarget);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, nodeCopy, uuidReferences) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    uuidCopy: nodeUtils.getUUID(nodeCopy),
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

  if (nodeUtils.isRoot(node)) {
    return `Copy top global parameter '${nodeUtils.getName(node)}'.`;
  }

  if (nodeUtils.isParameterGlobal(node)) {
    return `Copy nested global parameter '${nodeUtils.getName(node)}'.`;
  }

  if (nodeUtils.isFunction(node)) {
    return `Copy function parameter '${nodeUtils.getName(node)}'.`;
  }

  return `Copy nested parameter '${nodeUtils.getName(node)}'.`;
}